export default {
  type: 'quote2',
  title: `Blockquote`,
  icon: `quote-left`,
  template: `
        <div contenteditable="false" feature-obj="feature" org-index="orgIndex" class="">
          <blockquote>
            <p  ng-repeat="el in feature.content_elements track by $index">
            {{el.content}}
            </p>
            <em>{{feature.citation.content}}</em>
          </blockquote>
        </div>`,
  propertyTemplate: `<quote-property-editor feature="feature"/>`,
  initialInflation: function () {
    return {
      type: 'quote2',
      subtype: 'blockquote',
      subtype_label: 'Blockquote',
      content_elements: [{ type: 'text', content: '' }],
      citation: {
        type: 'text',
        content: '',
      },
    }
  },
  openPropertyTemplateOnAdd: true,
}
